import React from 'react';
import Image from 'next/image';

const SmallSearchInput = ({ onSearch, onClearSearch, searchValue, className }) => (
  <div className={className}>
    <div className="relative">
      <span className="absolute flex left-4 transform top-1/2 -translate-y-1/2">
        <Image
          src="/static/images/global/icons/search.svg"
          loading="eager"
          width={24}
          height={24}
        />
      </span>
      <input
        type="text"
        className="focus-visible:outline-white focus-visible:outline rounded-lg w-full max-w-full bg-[#262626] border border-tundora pl-12 pr-5 py-2 text-white leading-8"
        placeholder="Search"
        onChange={onSearch}
        value={searchValue}
      />
      <button
        disabled={!searchValue}
        className="disabled:cursor-not-allowed absolute flex right-4 transform top-1/2 -translate-y-1/2"
        type="button"
        onClick={onClearSearch}
      >
        <Image src="/static/images/global/icons/cross.svg" loading="eager" width={14} height={14} />
      </button>
    </div>
  </div>
);

export default SmallSearchInput;
